import { render, staticRenderFns } from "./hfrmzx.vue?vue&type=template&id=54401d8f&"
import script from "./hfrmzx.vue?vue&type=script&lang=js&"
export * from "./hfrmzx.vue?vue&type=script&lang=js&"
import style0 from "./hfrmzx.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports